


const logotext = "Vastu Shelly Buildcon";
const meta = {
    title: "Vastu Shelly Buildcon",
    description: "A professional who designs and builds the infrastructure of today",
};

const introdata = {
    title: "Vastu Shelly Buildcon",
    animated: {
        first: "Professional Work",
        second: "Design Beautifull Architecture",
        third: "2D,3D design of building",
    },
    description: "A professional who designs and builds the infrastructure of today",
    your_img_url: require("./assets/images/vastu.jpg"),
};

const dataabout = {
    title: "A bit about my self",
    aboutme: "Home 🏘️ Design Solution by Vaastu Shelly Buildcon Pvt. Ltd.           Hello, I am an accomplished Civil Engineer and the founder of Vaastu Shelly Buildcon.    As a planning and designing engineer, I take on the responsibility of creating and executing plans for various engineering projects. My role requires a blend of technical abilities, innovative problem-solving skills, and expertise in project management., I play a vital role in ensuring that projects are completed on time, within budget, and to the highest standard.    As the founder of Vaastu Shelly Buildcon, I am dedicated to providing my clients with the highest quality construction solutions. With my extensive knowledge of the industry and my unwavering commitment to excellence.",
};
const worktimeline = [{
        jobtitle: "Designer of week",
        where: "Dewas",
        date: "2022",
    },
    {
        jobtitle: "Designer of week",
        where: "Ujjain",
        date: "2022",
    },
    {
        jobtitle: "Designer of week",
        where: "Indore",
        date: "2023",
    },
];



const services = [{
        title: "★ Planning & Designing",
        description: " focuses on engineering design and problem solving, but also involves economic, environmental, social and ethical considerations.",
    },
    {
        title: "★ 3D Elevation",
        description: " To plan, design, and deliver land development, water, and transportation projects.",
    },
    {
        title: "★ Interior Designing",
        description: "Building construction skills have imbibed a level of perfection in the working of a civil engineer. This becomes his key strength while practising as an interior designer.",
    },
    {
        title: "★ Renovation",
        description: " improving or modernising an old, damaged or defective building.",
    },
     {
        title: "★ Construction",
        description: " the actual construction and maintenance of civil engineering projects.",
    },
    {
        title: "★ Vaastu Consultant",
        description: "A Vastu expert or a vastu consultant is capable of analyzing your structure of home or office or factory. ",
    },
];

const dataportfolio = [
    
    {
        img: require("./assets/images/mm.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "",
    },
    {
        img: require("./assets/images/bb.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: require("./assets/images/cc.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "",
    },
    {
        img: require("./assets/images/dd.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: require("./assets/images/ee.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: require("./assets/images/ff.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },

    {
        img: require("./assets/images/gg.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: require("./assets/images/hh.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: require("./assets/images/ii.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: require("./assets/images/jj.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: require("./assets/images/kk.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: require("./assets/images/ll.jpg"),
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
];

const contactConfig = {
    YOUR_EMAIL: "vaastushelly@gmail.com",
    YOUR_FONE: "(+91)8109176625 , (+91)9575721976" ,
    
    description: "As the founder of Vaastu Shelly Buildcon, I am dedicated to providing my clients with the highest quality construction solutions. With my extensive knowledge of the industry and my unwavering commitment to excellence.",
    // creat an emailjs.com account 
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    YOUR_SERVICE_ID: "service_id",
    YOUR_TEMPLATE_ID: "template_id",
    YOUR_USER_ID: "user_id",
};

const socialprofils = {
    
    facebook: "https://www.facebook.com/search/top?q=vastu%20shelly",
    
    twitter: "https://twitter.com/Vaastushelly?s=20",
    instagram: "https://www.instagram.com/vaastu_shelly_buildcon/",
};
export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,

    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};